module.exports = __webpack_public_path__ + "static/media/exportShare.0971f9fb.svg";